module.exports = __webpack_public_path__ + "img/Transparant@2x.94d62d52.png";